// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__4nOez","slideNotification":"Notification_slideNotification__QPa3E"};